// src/components/Footer.jsx
import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-gray-100 dark:bg-neutral-900 border-t border-gray-200 dark:border-neutral-800 mt-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="py-6 sm:py-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-between">
          {/* Left: Copyright */}
          <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 text-center">
            © {year} Amend Finance LLC. All rights reserved.
          </p>

          {/* Right: Links */}
          <nav aria-label="Footer navigation">
            <ul className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <li>
                <a
                  href="https://www.amendfinance.com/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs sm:text-sm text-[#0057B8] hover:text-[#003e7e] underline underline-offset-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFD600] rounded"
                >
                  Privacy Policy
                </a>
              </li>
              <li className="hidden sm:block text-gray-400">•</li>
              <li>
                <a
                  href="https://www.amendfinance.com/terms-of-use"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs sm:text-sm text-[#0057B8] hover:text-[#003e7e] underline underline-offset-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFD600] rounded"
                >
                  Terms of Use
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
